import { OrganizationMemberClientAccessSource } from "@common/types/organizationMemberClientAccess";

export const ORGANIZATION_MEMBER_ACCESS_LOG_SOURCE_LABELS: Record<
    OrganizationMemberClientAccessSource,
    string
> = {
    [OrganizationMemberClientAccessSource.SWITCHER]: "Client switcher",
    [OrganizationMemberClientAccessSource.CLIENTS_LIST]: "Clients list",
    [OrganizationMemberClientAccessSource.HYDRATE]: "Page load",
    [OrganizationMemberClientAccessSource.OTHER]: "Other",
};
